import { OptionType } from "../../shared/components/BaseAsyncPaginate";

import { createLoadOptions } from "../../service/createLoadOptions";
import { GetCountryResponse } from "../models/response/get-country-response";
import { getPaginatedByNameCountries } from "./country-service";
import { GetCountriesResponse } from "../models/response/get-countries-response";


const fetchCountries = async (
  page: number,
  perPage: number,
  searchQuery?: string
): Promise<GetCountriesResponse> => {
  return getPaginatedByNameCountries({ page, perPage, searchQuery });
};

export const countriesMapper = (c: GetCountryResponse): OptionType => ({
  value: c.id,
  label: c.name,
});

export const loadCountries = createLoadOptions(fetchCountries, countriesMapper);
